module.exports = __webpack_public_path__ + "img/icon_map_11_off_110.b1abcc2a.png";